import styled from "styled-components";

export const DailySettlementTabWrapper = styled.div`
  width: 100%;
  height: 86px;
  border-radius: 14px;
  padding: 20px 18px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  box-shadow: 0px 2.83px 2.83px 0px #00000040;
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
`;

export const DailySettlementTabButtonWrapper = styled.div`
  display: flex;
  gap: 20px;

  > .button {
    height: 50px;
    border-radius: 15px;
    padding: 0 20px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    color: #bebebe;
    cursor: pointer;

    &.selected {
      background: #7f25fb;
      color: #ffffff;
    }
  }
`;

export const DailySettlementDateWrapper = styled.div`
  display: flex;
  gap: 12px;

  > .save {
    width: 50px;
    height: 50px;
    border-radius: 15px;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    > img {
      width: 30px;
      height: 30px;
    }
  }
`;
